import React from 'react';
import { useObservableState } from 'observable-hooks';
import { useHeyYabbleCountStepBLoC } from '../../HeyYabbleCountStep.bloc';
import { HStack, VStack } from 'components/layouts/primitives/Stack/Stack';
import { Text } from 'components/Text/Text';
import { HeyYabbleCountStepSummaryStyle as S } from './HeyYabbleCountStepSummary.style';
import { Divider } from 'components/Divider/Divider';
import { FormattedNumber } from 'components/FormattedNumber/FormattedNumber';

export const HeyYabbleCountStepSummary: React.FC = () => {
  const { $costValues } = useHeyYabbleCountStepBLoC();
  const costValues = useObservableState($costValues);

  return (
    <S.Container backgroundColor="neutral50" radius="roundedMD" padding="paddingXL">
      <VStack gap="gap4">
        <Text size="fontSizeXS" color="neutral400" weight="semiBold">
          TRANSACTION SUMMARY
        </Text>
        <VStack gap="gap4">
          <VStack gap="gap2">
            <Text color="neutral600" size="fontSizeSM" lineHeight="lineHeightMD">
              Gen
            </Text>
            <S.List>
              <li>
                <Text color="neutral400" size="fontSizeSM" lineHeight="lineHeightMD">
                  <FormattedNumber num={costValues?.genCount} /> rows
                </Text>
              </li>
            </S.List>
            <HStack align="center" justify="space-between">
              <Text color="neutral600" size="fontSizeSM" lineHeight="lineHeightMD">
                Sub-total
              </Text>
              <Text color="neutral600" size="fontSizeSM" lineHeight="lineHeightMD">
                {(costValues?.genCost || 0) > 0 && '-'}
                <FormattedNumber num={costValues?.genCost} />
              </Text>
            </HStack>
          </VStack>
          <VStack gap="gap2">
            <Text color="neutral600" size="fontSizeSM" lineHeight="lineHeightMD">
              Count
            </Text>
            <S.List>
              <li>
                <Text color="neutral400" size="fontSizeSM" lineHeight="lineHeightMD">
                  <FormattedNumber num={costValues?.rowsCount} /> rows
                </Text>
              </li>
              {costValues?.hasCodeFrames && (
                <li>
                  <Text color="neutral400" size="fontSizeSM" lineHeight="lineHeightMD">
                    Codeframe enabled
                  </Text>
                </li>
              )}
            </S.List>
            <HStack align="center" justify="space-between">
              <Text color="neutral600" size="fontSizeSM" lineHeight="lineHeightMD">
                Sub-total
              </Text>
              <Text color="neutral600" size="fontSizeSM" lineHeight="lineHeightMD">
                {(costValues?.rowsCost || 0) > 0 && '-'}
                <FormattedNumber num={costValues?.rowsCost} />
              </Text>
            </HStack>
          </VStack>
          <Divider color="gray200" />
          <VStack gap="gap2">
            <HStack align="center" justify="space-between">
              <Text color="neutral600" size="fontSizeSM" lineHeight="lineHeightMD">
                Total
              </Text>
              <Text color="neutral600" size="fontSizeSM" lineHeight="lineHeightMD">
                {(costValues?.total || 0) > 0 && '-'}
                <FormattedNumber num={costValues?.total} />
              </Text>
            </HStack>
            <HStack align="center" justify="space-between">
              <Text color="neutral600" size="fontSizeSM" lineHeight="lineHeightMD">
                Available credits
              </Text>
              <Text color="neutral600" size="fontSizeSM" lineHeight="lineHeightMD">
                <FormattedNumber num={costValues?.credits} />
              </Text>
            </HStack>
          </VStack>
          <Divider color="gray200" />
          <HStack gap="gap2" align="center" justify="space-between">
            <Text color="neutral600" size="fontSizeSM" lineHeight="lineHeightMD" weight="semiBold">
              Remaining balance
            </Text>
            <Text color="neutral600" size="fontSizeSM" lineHeight="lineHeightMD" weight="semiBold">
              <FormattedNumber num={costValues?.remaining} />
            </Text>
          </HStack>
        </VStack>
      </VStack>
    </S.Container>
  );
};
